export enum OperatorAppRoutes {
    Home = 'Home',
    Zones = 'Zones',
    ZonesList = 'ZonesList',
    ZonesDetail = 'ZonesDetail',
    Parkings = 'Parkings',
    ParkingsList = 'ParkingsList',
    ParkingsDetail = 'ParkingsDetail',
    ClearancesPermitsList = 'ClearancesPermitsList',
    ClearanceRequests = 'ClearanceRequests',
    Logins = 'Logins',
    LoginCreate = 'LoginCreate',
    LoginDetail = 'LoginDetail',
    ConfirmOtp = 'ConfirmOtp',
    ActivityStatement = 'ActivityStatement',
    OnstreetTransactions = 'OnstreetTransactions',
    OnstreetTransactionsContractDetail = 'OnstreetTransactionsContractDetail',
    CustomerAccounts = 'CustomerAccounts',
    SpecialReports = 'SpecialReports',
    PermitTypes = 'PermitTypes',
    PermitTypesDetail = 'PermitTypesDetail',
    ParkingMeters = 'ParkingMeters',
    Tariffs = 'Tariffs',
    TariffDetails = 'TariffDetails',
    UsbSticks = 'UsbSticks',
    EnforcementLog = 'EnforcementLog',
    EnforcementLogDetail = 'EnforcementLogDetail',
    Parkmonitor = 'Parkmonitor',
    MiOffice = 'MiOffice',
    Downloads = 'Downloads',
    Password = 'Password',
    LoginProfile = 'LoginProfile',
    ParkingaboUsers = 'ParkingaboUsers',
    ParkingaboUsersAdd = 'ParkingaboUsersAdd',
    ParkingaboUsersInvite = 'ParkingaboUsersInvite',
    ParkingaboUsersDetail = 'ParkingaboUsersDetail',
    ParkingaboUsersProducts = 'ParkingaboUsersProducts',
    ParkingaboUsersProductsAdd = 'ParkingaboUsersProductsAdd',
    ParkingaboUsersProductsDetail = 'ParkingaboUsersProductsDetail',
    ParkingaboUsersTransactions = 'ParkingaboUsersTransactions',
    ParkingaboUsersVehicles = 'ParkingaboUsersVehicles',
    ParkingaboUsersVehiclesAdd = 'ParkingaboUsersVehiclesAdd',
    ParkingaboUsersVehiclesDetail = 'ParkingaboUsersVehiclesDetail',
    ParkingaboUsersAccountStatement = 'ParkingaboUsersAccountStatement',
    OffstreetTransactions = 'OffstreetTransactions',
    OffstreetTransactionsTicketDetail = 'OffstreetTransactionsTicketDetail',
    OffstreetTransactionsTicketLostDetail = 'OffstreetTransactionsTicketLostDetail',
    OffstreetTransactionsEntryWithoutExitDetail = 'OffstreetTransactionsEntryWithoutExitDetail',
    OffstreetTransactionsContractDetail = 'OffstreetTransactionsContractDetail',
    OffstreetGuestProducts = 'OffstreetGuestProducts',
    OffstreetGuestReservationAdd = 'OffstreetGuestReservationAdd',
    OffstreetGuestReservationAddSuccess = 'OffstreetGuestReservationAddSuccess',
    OffstreetGuestDayPassOverview = 'OffstreetGuestDayPassOverview',
    OffstreetGuestDayPassAdd = 'OffstreetGuestDayPassAdd',
    OffstreetEvents = 'OffstreetEvents',
    OffstreetEventsAdd = 'OffstreetEventsAdd',
    OffstreetEventEdit = 'OffstreetEventEdit',
    OffstreetEventCards = 'OffstreetEventCards',
    OffstreetEventCardsEditStack = 'OffstreetEventCardsEditStack',
    OffstreetEventCardsAddStack = 'OffstreetEventCardsAddStack',
    ParkingaboProducts = 'ParkingaboProducts',
    ParkingaboRoles = 'ParkingaboRoles',
    ParkingaboProductsDetail = 'ParkingaboProductsDetail',
    ParkingaboProductTypes = 'ParkingaboProductTypes',
    ParkingaboProductTypesDetail = 'ParkingaboProductTypesDetail',
    QuotasDetail = 'QuotasDetail',
    QuotasReduction = 'QuotasReduction',
    QuotasOverview = 'QuotasOverview',
    StatisticsCheckins = 'StatisticsCheckins',
    StatisticsPermits = 'StatisticsPermits',
    CloudConnectorPeripheries = 'CloudConnectorPeripheries',
    CloudConnectorPeripheriesFullscreen = 'CloudConnectorPeripheriesFullscreen',
    CloudConnectorPeripheriesDetail = 'CloudConnectorPeripheriesDetail',
    CloudConnectorPayStationManualCorrection = 'CloudConnectorPayStationManualCorrection',
    CloudConnectorPeripheryDetailStatus = 'CloudConnectorPeripheryDetailStatus',
    CloudConnectorPeripheryDetailPresence = 'CloudConnectorPeripheryDetailPresence',
    CloudConnectorRecodeStatements = 'CloudConnectorRecodeStatements',
    CloudConnectorAutoRecode = 'CloudConnectorAutoRecode',
    CloudConnectorAutoRecodeCreate = 'CloudConnectorAutoRecodeCreate',
    CloudConnectorAutoRecodeEdit = 'CloudConnectorAutoRecodeEdit',
    CloudConnectorRecodeQrCodes = 'CloudConnectorRecodeQrCodes',
    CloudConnectorRecodeQrCodesAdd = 'CloudConnectorRecodeQrCodesAdd',
    CloudConnectorRecode = 'CloudConnectorRecode',
    CloudConnectorRecodeSuccessResponse = 'CloudConnectorRecodeSuccessResponse',
    CloudConnectorRecodeErrorResponse = 'CloudConnectorRecodeErrorResponse',
    CloudConnectorRecodeLicsenPlateSerach = 'CloudConnectorRecodeLicsenPlateSerach',
    CloudConnectorRecodeEntryWithoutExit = 'CloudConnectorRecodeEntryWithoutExit',
    CloudConnectorRecodeEntryWithoutExitCondition = 'CloudConnectorRecodeEntryWithoutExitCondition',
    CloudConnectorCounterOverview = 'CloudConnectorCounterOverview',
    CloudConnectorCounterDetail = 'CloudConnectorCounterDetail',
    CloudConnectorGenerateGuestPermit = 'CloudConnectorGenerateGuestPermit',
    CloudConnectorGenerateGuestPermitSuccess = 'CloudConnectorGenerateGuestPermitSuccess',
    CloudConnectorGenerateGuestPermitError = 'CloudConnectorGenerateGuestPermitError',
    CloudConnectorSmartCall = 'CloudConnectorSmartCall',
    CloudConnectorSmartCallProfiles = 'CloudConnectorSmartCallProfiles',
    CloudConnectorSmartCallProfileAdd = 'CloudConnectorSmartCallProfileAdd',
    CloudConnectorSmartCallProfileDetails = 'CloudConnectorSmartCallProfileDetails',
    CloudConnectorSmartCallWeeklyPlan = 'CloudConnectorSmartCallWeeklyPlan',
    CloudConnectorSmartCallIndividualDates = 'CloudConnectorSmartCallIndividualDates',
    PayStationStatement = 'PayStationStatement',
    PayStationCollections = 'PayStationCollections',
    PeripheryHistory = 'PeripheryHistory',

    MobileHomePage = 'MobileHomePage',
    MobileCloudConnectorPeripheries = 'MobileCloudConnectorPeripheries',
    MobileCloudConnectorSettings = 'MobileCloudConnectorSettings',
    MobileCloudCounterOverview = 'MobileCloudCounterOverview',
    MobileCloudCounterDetail = 'MobileCloudCounterDetail',

    Privacy = 'Privacy',
}
